export const EVENT_USER_PROPERTIES_UPDATE = 'user_properties_update';